export default "__VITE_ASSET__OUMrDXRl__"